import type { ListingAudience } from '../analytics/client';
import './visibility.css';

/** Only staff see the public rollout metadata accompanying their flag result. */
export default function ListingVisibilityBadge({ audience, flagId, flagKey }: { audience: ListingAudience; flagId?: number; flagKey?: string }) {
  const percentage = audience === 'unknown' ? null : audience.publicRolloutPercent;
  const label = percentage === null ? 'Rollout unknown' : percentage === 0 ? 'Internal only' : percentage === 100 ? 'Public · 100%' : `Public rollout · ${percentage}%`;
  return (
    <details className="listing-visibility">
      <summary>{label}</summary>
      <p>{percentage === null
        ? 'The flag did not supply a public rollout percentage.'
        : percentage === 0
          ? 'Only 240 staff can see this card. The general audience is at 0%.'
          : `The configured public rollout is ${percentage}%. Staff exceptions are separate from that percentage.`}</p>
      <p>Staff-only listing information. Direct-link access is separate.</p>
      <a href={`https://us.posthog.com/project/558592/feature_flags/${flagId ?? `?search=${encodeURIComponent(flagKey ?? "")}`}`} target="_blank" rel="noreferrer">View visibility flag</a>
    </details>
  );
}
